import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Official policy contact",
    paragraphs: [`Customer-service and policy correspondence for ${STORE.brand} is received at ${STORE.supportEmail}. The store operates from ${STORE.operatingRegion}. Use the same contact for an order, cancellation, delivery, product-safety, privacy, accessibility, complaint or intellectual-property matter.`],
  },
  {
    title: "Information to include",
    items: [
      "a clear subject identifying the type of request;",
      "the order reference when the matter concerns a purchase;",
      "the affected item or page and the date the issue was discovered;",
      "a concise factual description and requested outcome;",
      "photographs or documents only when they are relevant and safe to create.",
    ],
  },
  {
    title: "Information to leave out",
    paragraphs: ["Messages must omit full card credentials, passwords and identity papers unrelated to the case. Start a delivery enquiry with the order reference; support can then name the smallest portion of destination information required to verify that request."],
  },
  {
    title: "Urgent safety and privacy wording",
    paragraphs: ["Begin the subject with Product safety when an item presents an active hazard and state how it has been isolated. Begin with Data request when asking to access or correct personal data. These labels help direct the message but do not change the underlying rights or evidence requirements."],
  },
  {
    title: "Keeping contact information consistent",
    paragraphs: ["Brand, operating region and customer-service email are drawn from the store's central configuration. A future business-detail change must be reviewed across Contact, About, the footer, checkout context, policy pages, metadata and customer messages before publication."],
  },
];

export default function ContactPolicy() {
  return <PolicyPage title="Contact Information Policy" intro="The verified contact channel, safe message contents and routing for customer requests." sections={sections} related={[["Complaints & Policy Updates", "/complaints"], ["Consumer Data Rights", "/data-rights"], ["Product Safety & Care", "/product-safety"]]} />;
}
